//
import Service from '@/services/api/service'
import ProviderModel from '@/models/Purchase/PchProvider'

//
//import filters    from './filters'
//import headers    from './headers'
import includes from './includes'

//
export default class extends Service {

    //
    //static filters  = filters
    //static headers  = headers
    static includes = includes
    
    //
    static model = ProviderModel
}
